import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTree"><Path d="M12 21.5V15.5M12 15.5L9.5 13M12 15.5L15.5 12M20.5 11C20.5 15.6944 16.6944 19.5 12 19.5C7.30558 19.5 3.5 15.6944 3.5 11C3.5 6.30558 7.30558 2.5 12 2.5C16.6944 2.5 20.5 6.30558 20.5 11Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTree;
